module.exports = __webpack_public_path__ + "static/img/14001014.d7345c4c.png";